(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["happycloths-collections"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hc-collections').forEach(function(root){
  if(root.dataset.ready==='true')return;
  root.dataset.ready='true';
  var rail=root.querySelector('[data-hc-collections-rail]');
  var prev=root.querySelector('[data-hc-collections-prev]');
  var next=root.querySelector('[data-hc-collections-next]');
  function move(direction){
    if(!rail)return;
    var card=rail.querySelector('.hc-collections__card');
    var distance=card?card.getBoundingClientRect().width+16:320;
    rail.scrollBy({left:distance*direction,behavior:'smooth'});
  }
  if(prev)prev.addEventListener('click',function(){move(-1)});
  if(next)next.addEventListener('click',function(){move(1)});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
